import React, { Component } from "react";

import { withStyles } from "@material-ui/core/styles";

import $ from "jquery";

import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Input,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Paper,
  Typography,
  FormHelperText
} from "@material-ui/core";

import CreateStoreTest from "../../components/create-store/create-store-test";

const styles = theme => ({
  mainRequest: {
    display: "flex",
    flexDirection: "column",
    padding: ".5rem",
    flexGrow: 1
  },
  paperCls: {
    padding: "0rem .5rem",
    display: "flex",
    flexDirection: "column"
  },
  textField: {
    marginTop: "1rem",
    "& p": {
      color: "red"
    }
  },
  formControl: {
    marginTop: "1.5rem"
  },
  mb1: {
    marginBottom: "1.5rem"
  },
  storeGroup: {
    display: "flex"
  },
  storeFilter: {
    marginRight: ".5rem"
  },
  storeSelect: {
    marginRight: ".5rem",
    flexGrow: "1"
  },
  storeFilterToggle: {
    whiteSpace: "nowrap",
    marginLeft: ".1rem",
    marginTop: ".75rem",
    marginRight: ".25rem"
  },
  badgecls: {
    // width:25,
    // height:25,
    left: 32
  },
  headerStyle: {
    color: "#6975c3"
  },

  diagHeader: {
    "& h6": {
      padding: ".5rem",
      color: "whitesmoke",
      fontWeight: "bold",
      fontSize: "1.5rem"
    }
  },
  diagHeaderBg: {
    color: "#7ac17a"
  },
  diagContentText: {
    fontSize: "1.25rem"
  },

  errorBgCol: {
    backgroundColor: "rgba(135, 6, 0, 0.78);"
  },
  successBgCol: {
    backgroundColor: "#7ac17a"
  },

  requiredText: {
    color: "#ec5353",
    marginLeft: ".5rem"
  }
});

class WorkRequest extends Component {
  constructor() {
    super();

    this.state = {
      isProd: true,
      filterTerm: "",
      
      selectedStore: -99,
      selectedSeverity: -99,
      selectedBillingCategory: -99,

      storeItems: [],
      severityItems: [],
      billingCategoryItems: [],

      requestedBy: "",
      description: "",
      instructions: "",
      tracking: "",
      nteLimit: "",

      modalIsOpen: false,
      hasCreationError: false,
      title: "",
      body: ""
    };
  }

  componentWillMount = () => {
    this.getSeverityList();
    this.getBillingCategoryList();
    this.getStoreListing();
    this.getNetAmount();
  };

  getSeverityList() {
    let url = this.state.isProd
      ? `/api/severity`
      : `https://localhost:44331/api/severity`;

    $.ajax({
      type: "POST",
      url: url,
      data: {
        customerid: this.props.customerDetail.Id
      },
      success: result => {
        let resultFormed = JSON.parse(result);
        console.log({ resultFormed });

        this.setState({
          severityItems: resultFormed.items
        });
      },
      error: result => {
        console.error(result);
      }
    });
  }

  getNetAmount() {
    let url = this.state.isProd
      ? `/api/getNteAmount`
      : `https://localhost:44331/api/getNteAmount`;

    $.ajax({
      type: "POST",
      url: url,
      data: {
        customerid: this.props.customerDetail.Id
      },
      success: result => {
        let resultFormed = JSON.parse(result);
        console.log({ resultFormed });

        this.setState({
          nteLimit: resultFormed.amount
        });
      },
      error: result => {
        console.error(result);
      }
    });
  }

  getBillingCategoryList() {
    let url = this.state.isProd
      ? `/api/billingCategory`
      : `https://localhost:44331/api/billingCategory`;

    $.ajax({
      type: "POST",
      url: url,
      data: {
        customerid: this.props.customerDetail.Id
      },
      success: result => {
        let resultFormed = JSON.parse(result);
        console.log({ resultFormed });


        this.setState({
          billingCategoryItems: resultFormed.items
        });
      },
      error: result => {
        console.error(result);
      }
    });
  }

  getStoreListing() {
    let url = this.state.isProd
      ? `/api/store`
      : `https://localhost:44331/api/store`;

    $.ajax({
      type: "POST",
      url: url,
      data: {
        customerId: this.props.customerDetail.Id,
        filterterm: this.state.filterTerm
      },
      success: result => {
        let resultFormed = JSON.parse(result);
        console.log({ resultFormed });

        //   if(resultFormed.result !== 0){
        //     this.props.loginEvent(resultFormed.result);
        //     return;
        //   }

        this.setState({
          storeItems: resultFormed.items
        });
      },
      error: result => {
        console.error(result);
      }
    });
  }

  handleStoreFilterChange = evt => {
    this.setState(
      {
        filterTerm: evt.target.value
      },
      () => this.getStoreListing()
    );
  };

  handleStoreSelection = evt => {
    this.setState({
      selectedStore: evt.target.value
    });
  };

  handleSeveritySelection = evt => {
    this.setState({
      selectedSeverity: evt.target.value
    });
  };

  handleBillingCategorySelection = evt => {
    this.setState({
      selectedBillingCategory: evt.target.value
    });
  };
  handleToggle = evt => {
    this.setState({
      useFilter: evt.target.checked
    });
  };

  canSubmit = () => {
    return (
      this.state.selectedSeverity === -99 ||
      this.state.selectedStore === -99 ||
      this.state.selectedBillingCategory === -99 ||
      this.state.description.length < 12 ||
      this.state.nteLimit === null ||
      this.state.nteLimit === "" 
    );
  };

  handleSubmitClick = () => {
    this.submitWorkRequest();
  };

  reset = () => {
    this.setState({
      filterTerm: "",

      selectedStore: -99,
      selectedSeverity: -99,
      selectedBillingCategory: -99,

      description: "",
      instructions: "",
      trackingNo: "",
      nteLimit: "",

      modalIsOpen: false,
      hasCreationError: false,
      title: "",
      body: ""
    });
  };

  submitWorkRequest() {
    let dataObject = {
      customerid: this.props.customerDetail.Id,
      storeid: this.state.selectedStore,
      responsetimeid: this.state.selectedSeverity,
      billingcategoryid: this.state.selectedBillingCategory,
      requestedBy: this.state.requestedBy,
      customerdescription: this.state.description,
      instructions: this.state.instructions,
      trackingno: this.state.trackingNo,
      nteamount: this.state.nteLimit
    };

    let url = this.state.isProd
      ? `/api/submitrequest`
      : `https://localhost:44331/api/submitrequest`;

    $.ajax({
      type: "POST",
      url: url,
      data: dataObject,
      success: result => {
        let resultFormed = JSON.parse(result);
        debugger;
        console.log({ resultFormed });

        this.setState(
          {
            hasCreationError: !resultFormed.isSuccessful
          },
          () => {
            this.handleCreationResult();
          }
        );
      },
      error: result => {
        console.error(result);
      }
    });
  }

  handleCreationResult() {
    this.setModal();
    this.handleOpen();
  }

  handleClose = () => {
    if (!this.state.hasCreationError) {
      this.reset();
    }
    this.setState({
      modalIsOpen: false
    });
  };

  handleOpen = () => {
    this.setState({
      modalIsOpen: true
    });
  };

  setModal = () => {
    let title = "";
    let body = "";

    if (this.state.hasCreationError) {
      title = "Work Request Creation Failure";
      body = "Unable to create work request, please contact your ACS support.";
    } else {
      title = "Work Request has been recieved ! ";
      body =
        "Thank you for your request for service.  Your Request has been successfully submitted.  The store will be called and a tech scheduled.";
    }

    this.setState({
      title,
      body
    });
  };

  handleRequesterUpdate = evt => {
    this.setState({
      requestedBy: evt.target.value
    });
  };

  handleDescriptionUpdate = evt => {
    this.setState({
      description: evt.target.value
    });
  };

  handleInstructionUpdate = evt => {
    this.setState({
      instructions: evt.target.value
    });
  };

  handleTrackingNoUpdate = evt => {
    this.setState({
      trackingNo: evt.target.value
    });
  };

  handleNTELimitUpdate = evt => {
    this.setState({
      nteLimit: evt.target.value
    });
  };

  handleAddStoreLocation = () => {
    alert("stor location add feature not implemented");
  };

  addedStoreEvent = storeId => {
    this.setState(
      {
        selectedStore: storeId
      },
      () => this.getStoreListing()
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <Paper className={classes.mainRequest}>
        <Typography
          variant="h4"
          gutterBottom
          align="center"
          className={classes.headerStyle}
        >
          Service Request
        </Typography>

        <div className={classes.storeGroup}>
          <FormControl className={classes.storeFilter}>
            <InputLabel
              htmlFor="adornment-password"
              className={classes.inputField}
            >
              StoreFilter
            </InputLabel>
            <Input
              className={classes.inputField}
              id="adornment-password"
              type="text"
              value={this.state.textValue}
              onChange={this.handleStoreFilterChange}
            />
          </FormControl>

          <FormControl className={classes.storeSelect}>
            <InputLabel htmlFor="store-select">
              Store<span className={classes.requiredText}> (Required)</span>
              <Badge
                className={classes.badgecls}
                color="secondary"
                badgeContent={this.state.storeItems.length}
              >
                ''
              </Badge>
            </InputLabel>

            <Select
              value={this.state.selectedStore}
              onChange={this.handleStoreSelection}
              // name="age"
              inputProps={{
                id: "store-select"
              }}
              className={classes.selectEmpty}
            >
              <MenuItem value={-99} disabled>
                <em>Select Store</em>
              </MenuItem>
              {this.state.storeItems.map(item => {
                return (
                  <MenuItem value={item.Id} key={item.StoreDetails.StoreNumber}>
                    {item.StoreDetails.CustomerAbbreviation +
                      " - " +
                      item.StoreDetails.StoreNumber}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <CreateStoreTest
            customerDetail={this.props.customerDetail}
            addedStoreEvent={this.addedStoreEvent}
          />
        </div>

        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="severity-select">
            Severity<span className={classes.requiredText}> (Required)</span>
          </InputLabel>
          <Select
            value={this.state.selectedSeverity}
            onChange={this.handleSeveritySelection}
            name="severity"
            inputProps={{
              id: "severity-select"
            }}
            className={classes.selectEmpty}
          >
            <MenuItem value={-99} disabled>
              <em>Select Severity</em>
            </MenuItem>
            {this.state.severityItems.map(item => {
              return (
                <MenuItem value={item.ID} key={item.ID}>
                  {item.Descr}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="billing-category">
            Billing Category{" "}
            <span className={classes.requiredText}> (Required)</span>
          </InputLabel>
          <Select
            value={this.state.selectedBillingCategory}
            onChange={this.handleBillingCategorySelection}
            name="age"
            inputProps={{
              id: "billing-category"
            }}
            className={classes.selectEmpty}
          >
            <MenuItem value={-99} disabled>
              <em>Select Billing Category</em>
            </MenuItem>
            {this.state.billingCategoryItems.map(item => {
              return (
                <MenuItem value={item.ID} key={item.ID}>
                  {item.Description}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="requester">
            Requested By{" "}
          </InputLabel>
          <Input
            placeholder="Who is Requesting"
            multiline
            className={classes.textField}
            onChange={this.handleRequesterUpdate}
            value={this.state.requestedBy}
            inputProps={{
              id: "requester"
            }}
          >
            test
          </Input>
        </FormControl>

        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="description">
            Description of Problem{" "}
            <span className={classes.requiredText}> (Required)</span>
          </InputLabel>
          <Input
            placeholder="How can we help?"
            multiline
            className={classes.textField}
            onChange={this.handleDescriptionUpdate}
            value={this.state.description}
            inputProps={{
              id: "description"
            }}
          >
            test
          </Input>
        </FormControl>

        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="nte-limit">
            NTE Limit <span className={classes.requiredText}> (Required)</span>
          </InputLabel>
          <Input
            className={[classes.textField, classes.mb1].join(" ")}
            // margin="normal"
            onChange={this.handleNTELimitUpdate}
            value={this.state.nteLimit}
            inputProps={{
              id: "nte-limit"
            }}
          >
            test
          </Input>
        </FormControl>

        <TextField
          label="Instructions/Comments (optional)"
          //   placeholder=""
          multiline
          className={[classes.textField, classes.mb1].join(" ")}
          margin="normal"
          onChange={this.handleInstructionUpdate}
          value={this.state.instructions}
        />

        <TextField
          label="Tracking/PO (optional)"
          //   placeholder=""
          // multiline
          className={[classes.textField, classes.mb1].join(" ")}
          margin="normal"
          onChange={this.handleTrackingNoUpdate}
          value={this.state.trackingNo}
        />

        <Button
          disabled={this.canSubmit()}
          variant="contained"
          color="primary"
          className={[classes.button, classes.mt1, classes.mb0].join(" ")}
          onClick={this.handleSubmitClick}
        >
          Submit Request
        </Button>

        <Dialog
          open={this.state.modalIsOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            classes={{
              root: [
                classes.diagHeader,
                this.state.hasCreationError
                  ? classes.errorBgCol
                  : classes.successBgCol
              ].join(" ")
            }}
            id="alert-dialog-title"
          >
            {this.state.title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              classes={{ root: classes.diagContentText }}
              id="alert-dialog-description"
            >
              {this.state.body}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={this.handleClose}
              color="primary"
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    );
  }
}

export default withStyles(styles)(WorkRequest);
